import React, { useEffect, useState }               from 'react';
import { Props }                                    from './Handbooks.types';
import { useRouteMatch }                            from 'react-router';
import configs                                      from './configs';
import { HandbookSingle }                           from './HandbookSingle';
import { HandbookList }                             from './HandbookList';
import { getList as getListRequest, ITableRequest } from 'api/handbooks/table';
import { apiTypes }                                 from 'shared/consts/handbooksApiTypes';

const getConnectionFilter = (conConf: any): ITableRequest => {
  return {
    schema: conConf.schema,
    table: conConf.table,
    fields: [...conConf.fields, conConf.index],
    customsql: conConf.customsql,
    sort: {
      field: conConf.fields.length > 0 ? conConf.fields[0] : conConf.index,
      direction: 'asc',
    },
    apiType: apiTypes.DEFAULT,
  };
};

export const HandbookPage: React.FC<Props> = (props: Props) => {
  const { params } = useRouteMatch<{ type: string; id: string }>();

  const [connections, setConnections] = useState({});

  const config = configs[params.type];
  const indexField = config.fields.find((el: any) => !!el.index).name;

  const reloadConnections = async () => {
    let connlist = {};
    //Object.keys(config.connections || {}).forEach(async (conName: string) => {
    for(let conName in config.connections || {}){
      const conConf = config.connections[conName];
      const data = await getListRequest(getConnectionFilter(conConf));
      const list = (data && data.list) || [];
      connlist = { ...connlist, ...{ [conName]: list } };
    };
    setConnections(connlist);
  };

  useEffect(() => {
    reloadConnections();
  }, [params.type]);

  return (
    <>
      {params.id ? (
        <HandbookSingle
          type={params.type}
          config={config}
          id={parseInt(params.id)}
          connections={connections}
          indexFieldName={indexField}
        />
      ) : (
        <HandbookList
          type={params.type}
          config={config}
          connections={connections}
          indexFieldName={indexField}
        />
      )}
    </>
  );
};
